import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '@framework/router';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import { useLeagueTableContext } from '@/creditflowresearch/application/League/Table/LeagueTableContext';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';

const TopUnderwriters = (props) => {
  const { query: { products, regions } } = useRouter();
  const {
    state: leagueTableState,
    paginateTopUnderwriters,
    getTopUnderwritersByFilter,
    resetTopUnderwriters,
  } = useLeagueTableContext();
  const { state: filtersState } = useLeagueTableFiltersContext();
  const { page, perPage } = leagueTableState.topUnderwritersCollection;
  const selectedPeriod = filtersState.periods.topUnderwriters.selected;
  const didMount = useRef(false);

  const [isPagesReset, setIsPagesReset] = useState(false);

  const onPageChange = (page) => {
    paginateTopUnderwriters(page.selected);
  };

  useEffect(() => () => {
    resetTopUnderwriters();
  }, []);

  useEffect(() => {
    if (didMount.current) {
      getTopUnderwritersByFilter();
    }
  }, [perPage, page]);

  useEffect(() => {
    if (didMount.current) {
      paginateTopUnderwriters(1);
      setIsPagesReset(true);
    } else {
      didMount.current = true;
    }
  }, [selectedPeriod, products, regions]);

  useEffect(() => {
    if (isPagesReset) {
      getTopUnderwritersByFilter();
      setIsPagesReset(false);
    }
  }, [isPagesReset]);

  return (
    <LinkTable
      { ...props }
      { ...leagueTableState.topUnderwritersCollection }
      onPageChange={ onPageChange }
      dataTest="topUnderwritersLeagueTable"
    />
  );
};

export default TopUnderwriters;
